import { Link } from 'react-router-dom'
import type { AktivZeile } from '../../hooks/instrumentRegeln'
import s from './AktivitaetKarte.module.scss'

/**
 * Eine Karte rechts auf der Instrumentseite: Fälle, News, Einschätzungen
 * oder Ideen zu diesem Titel.
 *
 * Kopf mit Titel, der Anzahl als Plakette und dem Sprung auf die ganze
 * Liste; darunter die jüngsten Zeilen, jede mit Marke, Titel, Unterzeile
 * und Zeit. Ein Klick öffnet das Detail in der Schublade — die Karte zeigt
 * nur an, wer gerade offen ist.
 */
export function AktivitaetKarte({ titel, anzahl, alle, zeilen, aktiv, leer, onWaehle }: {
  titel: string
  /** Wie viele es insgesamt gibt — mehr, als die Karte zeigt. */
  anzahl: number
  /** Wohin „alle n ›" führt. */
  alle: string
  zeilen: AktivZeile[]
  /** Der Schlüssel der Zeile, deren Detail offen ist. */
  aktiv: string | null
  leer: string
  onWaehle: (zeile: AktivZeile) => void
}) {
  return (
    <section className={s.karte}>
      <div className={s.kopf}>
        <span className={s.titel}>{titel}</span>
        <span className={s.plakette}>{anzahl}</span>
        {anzahl > 0 && <Link to={alle} className={s.alle}>alle {anzahl} ›</Link>}
      </div>
      {zeilen.length === 0 && <div className={s.leer}>{leer}</div>}
      {zeilen.map((z, i) => (
        <button key={z.key} type="button" className={s.zeile}
                data-aktiv={aktiv === z.key || undefined}
                data-zebra={i % 2 === 1 || undefined} data-ton={z.ton}
                onClick={() => onWaehle(z)}>
          <span className={s.marke} data-ton={z.ton} data-gefuellt={z.gefuellt || undefined}>
            {z.marke}
          </span>
          <span className={s.text}>
            <span className={s.zeilenTitel}>{z.titel}</span>
            <span className={s.sub}>{z.sub}</span>
          </span>
          <span className={s.zeit} title={z.zeitVoll}>{z.zeit}</span>
        </button>
      ))}
    </section>
  )
}
